export const getItem = (name: string) => localStorage.getItem(name);

export const setItem = (name: string, value: string) =>
  localStorage.setItem(name, value);
